import type CK from '~/types/contentking';

import useBatchContext from '~/hooks/useBatchContext';



function useBatchContextWebsiteConfiguration(websiteId: CK.WebsiteId | null) {
	return useBatchContext(
		`websiteConfiguration/${websiteId ?? ''}`,
		10,
	);
}



export default useBatchContextWebsiteConfiguration;
